import dateTimeFormat from "@/core/filters/dateTimeFormat.filter";
import { DEV_OPS } from "@/core/api";
import { apiHelper } from "@/core/utils";
import {
  LOADING_OPEN_LOADING,
  LOADING_CLOSE_LOADING,
} from "@/core/store/loading.module";

/* Define Module Name */
const MODULE_NAME = "devOps/";

/* Define Action Name */
const A_GET_ACCOUNT_NAME = "getAccountName";
const A_CREATE_ACCOUNT = "createAccount";
const A_UDPATE_ACCOUNT = "updateAccount";
const A_DELETE_ACCOUNT = "deleteAccount";

/* Define Reset State Action Name */
const A_INITIAL_GET_ACCOUNT_NAME_STATE = "initialGetAccountNameState";
const A_INITIAL_CREATE_ACCOUNT_STATE = "initialCreateAccountState";
const A_INITIAL_UPDATE_ACCOUNT_STATE = "initialUpdateAccountState";
const A_INITIAL_DELETE_ACCOUNT_STATE = "initialDeleteAccountState";

/* Define Getter Name */

/* Define Mutation Name */
const M_GET_ACCOUNT_NAME = "setGetAccountName";
const M_CREATE_ACCOUNT = "setCreateAccount";
const M_UPDATE_ACCOUNT = "setUpdateAccount";
const M_DELETE_ACCOUNT = "setDeleteAccount";

/* Define Reset State Mutation Name */
const M_INITIAL_GET_ACCOUNT_NAME_STATE = "setInitialGetAccountNameState";
const M_INITIAL_CREATE_ACCOUNT_STATE = "setInitialCreateAccountState";
const M_INITIAL_UPDATE_ACCOUNT_STATE = "setInitialUpdateAccountState";
const M_INITIAL_DELETE_ACCOUNT_STATE = "setInitialDeleteAccountState";

/* Define Export Name */
export const DEV_OPS_GET_ACCOUNT_NAME = MODULE_NAME + A_GET_ACCOUNT_NAME;
export const DEV_OPS_CREATE_ACCOUNT = MODULE_NAME + A_CREATE_ACCOUNT;
export const DEV_OPS_UPDATE_ACCOUNT = MODULE_NAME + A_UDPATE_ACCOUNT;
export const DEV_OPS_DELETE_ACCOUNT = MODULE_NAME + A_DELETE_ACCOUNT;

/* Define Reset State Name */
export const DEV_OPS_INITIAL_GET_ACCOUNT_NAME_STATE =
  MODULE_NAME + A_INITIAL_GET_ACCOUNT_NAME_STATE;
export const DEV_OPS_INITIAL_CREATE_ACCOUNT_STATE =
  MODULE_NAME + A_INITIAL_CREATE_ACCOUNT_STATE;
export const DEV_OPS_INITIAL_UPDATE_ACCOUNT_STATE =
  MODULE_NAME + A_INITIAL_UPDATE_ACCOUNT_STATE;
export const DEV_OPS_INITIAL_DELETE_ACCOUNT_STATE =
  MODULE_NAME + A_INITIAL_DELETE_ACCOUNT_STATE;

const state = {
  accountName: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  createAccount: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  updateAccount: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  deleteAccount: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
};

//Getters
const getters = {};

// Actions
const actions = {
  [A_GET_ACCOUNT_NAME]({ dispatch, commit }, { data }) {
    // dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    DEV_OPS.getAccountName(data)
      .then((response) => {
        result = response;
        commit(M_GET_ACCOUNT_NAME, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_ACCOUNT_NAME, result);
        // dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_CREATE_ACCOUNT]({ dispatch, commit }, { data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    DEV_OPS.createAccount(data)
      .then((response) => {
        result = response;
        commit(M_CREATE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_CREATE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_UDPATE_ACCOUNT]({ dispatch, commit }, { id, data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    DEV_OPS.updateAccount(id, data)
      .then((response) => {
        result = response;
        commit(M_UPDATE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_UPDATE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_DELETE_ACCOUNT]({ dispatch, commit }, { id }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    DEV_OPS.deleteAccount(id)
      .then((response) => {
        result = response;
        commit(M_DELETE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_DELETE_ACCOUNT, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_INITIAL_GET_ACCOUNT_NAME_STATE]({ commit }) {
    commit(M_INITIAL_GET_ACCOUNT_NAME_STATE);
  },
  [A_INITIAL_CREATE_ACCOUNT_STATE]({ commit }) {
    commit(M_INITIAL_CREATE_ACCOUNT_STATE);
  },
  [A_INITIAL_UPDATE_ACCOUNT_STATE]({ commit }) {
    commit(M_INITIAL_UPDATE_ACCOUNT_STATE);
  },
  [A_INITIAL_DELETE_ACCOUNT_STATE]({ commit }) {
    commit(M_INITIAL_DELETE_ACCOUNT_STATE);
  },
};

// Mutations
const mutations = {
  [M_GET_ACCOUNT_NAME](state, result) {
    if (result.code === 200) {
      let d = result.data;
      state.accountName = {
        code: result.code,
        complete: true,
        data: d,
        message: null,
      };
      apiHelper.checkToken();
    } else {
      state.accountName = {
        code: result.code,
        complete: true,
        data: null,
        message: apiHelper.sortOutMessage(result.msg),
      };
    }
  },
  [M_CREATE_ACCOUNT](state, result) {
    state.createAccount = {
      code: result.code,
      complete: true,
      data: result.data,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_UPDATE_ACCOUNT](state, result) {
    state.updateAccount = {
      code: result.code,
      complete: true,
      data: result,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_DELETE_ACCOUNT](state, result) {
    state.deleteAccount = {
      code: result.code,
      complete: true,
      data: result,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_INITIAL_GET_ACCOUNT_NAME_STATE](state) {
    state.accountName = {
      code: 0,
      complete: false,
      data: null,
      message: null,
      pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
        lastPage: 0,
      },
    };
  },
  [M_INITIAL_CREATE_ACCOUNT_STATE](state) {
    state.createAccount = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_UPDATE_ACCOUNT_STATE](state) {
    state.updateAccount = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_DELETE_ACCOUNT_STATE](state) {
    state.deleteAccount = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
